import { shimmer } from "./shimmer";
import { toBase64 } from "./toBase64";

export const imagePlaceholder: any = `data:image/svg+xml;base64,${toBase64(shimmer(700, 475))}`;
